var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.logoSrc)?_c('v-avatar',{staticClass:"wgu-app-logo",attrs:{"size":_vm.logoSize,"tile":true}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"App Logo"}})]):_vm._e(),_vm._v(" "),(_vm.logoText)?_c('div',{staticClass:"wgu-app-logo"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.logoText)}})]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3a3afd8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLogo.vue
// module id = 01Ee
// module chunks = 1